import React from 'react';

interface ProductPriceProps {
  currentPrice: number;
  previousPrice?: number;
  isDiscounted: boolean;
}

export const ProductPrice: React.FC<ProductPriceProps> = ({
  currentPrice,
  previousPrice,
  isDiscounted
}) => {
  return (
    <div className="mt-2 flex items-center justify-between">
      <span className={`text-xl font-bold ${isDiscounted ? 'text-green-600' : ''}`}>
        {currentPrice.toFixed(2)}€
      </span>
      {isDiscounted && previousPrice && (
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-500 line-through">
            {previousPrice.toFixed(2)}€
          </span>
          <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded">
            Oferta
          </span>
        </div>
      )}
    </div>
  );
};